import { AxiosRequestConfig } from 'axios';

import { ICollectionActivity } from '~/types/ICollectionActivity';
import { PeriodType } from '~/types/IPurchase';
import { siteAxios } from '.';
import { get } from '../cookie';

type ArgumentsWithSlug = AxiosRequestConfig & { slug: string };

type CollectionActivitiesResponse = {
  activities: ICollectionActivity[];
};

type CollectionActivityLikeResponse = {
  likes: number;
};

type CreateMemoryBody = {
  image: string;
  content: string;
  period: PeriodType | null;
  by: string;
};

type CollectionSpecificMemory = {
  token: string;
  collection: string;
};

export const collectionActivities = {
  index: () =>
    siteAxios.get<CollectionActivitiesResponse>(`/api/v2/mw/collections/activities`),
  show: (args: ArgumentsWithSlug) =>
    siteAxios.get<CollectionActivitiesResponse>(
      `/api/v2/mw/collections/${args.slug}/activities`,
      {
        params: {
          ...args.params
        }
      }
    ),
  like: (id: string | number) =>
    siteAxios.post<CollectionActivityLikeResponse>(
      `/api/v2/mw/collections/activities/${id}/like`
    ),
  unlike: (id: string | number) =>
    siteAxios.post<CollectionActivityLikeResponse>(
      `/api/v2/mw/collections/activities/${id}/unlike`
    ),
  createMemory: (
    collection: number | string,
    { content, by, image }: CreateMemoryBody
  ) =>
    siteAxios.post<ICollectionActivity>(
      `/api/v2/mw/collections/${collection}/activities`,
      {
        type: 'memory',
        content,
        image,
        by
      },
      {
        headers: {
          'X-Session-Key': get('secretKey')
        }
      }
    ),
  getMemory: ({ collection, token }: CollectionSpecificMemory) =>
    siteAxios.get<ICollectionActivity>(
      `/api/v2/mw/collections/${collection}/activities/${token}`
    )
};
